import { render, staticRenderFns } from "./avatar_image.vue?vue&type=template&id=296a6cec&"
import script from "./avatar_image.vue?vue&type=script&lang=js&"
export * from "./avatar_image.vue?vue&type=script&lang=js&"
import style0 from "./avatar_image.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports